import React, { useState } from 'react';
import { samplePrompts } from '../../data/samplePrompts';
import { PromptFlow } from './PromptFlow';
import { PromptDemo } from './PromptDemo';
import { PromptCard } from './PromptCard';
export function PromptExplainer() {
  const [active, setActive] = useState(0);
  return <section aria-label="What is a prompt" className="bg-transparent" data-id="element-226" data-mp="3mkdfzmsnfz7t">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: '20px',
      paddingBottom: '24px'
    }} data-id="element-227" data-mp="3mika49pv1j0v">
        <div className="text-center" data-id="element-228" data-mp="3cmpmt1aoyzrr">
          <h2 className="font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-229" data-mp="3cns9ex0zeg1v">What is a prompt?</h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-plum/70" data-id="element-230" data-mp="2yo9ghbgqrba5">
            It's a <span className="font-bold text-grape" data-id="element-231" data-mp="33l9ago0bgnkw">master instruction</span>, optimized for AI.
          </p>
        </div>

        <PromptFlow data-id="element-232" data-mp="wwwdiryc3dgq" />
        <PromptDemo data-id="element-233" data-mp="wwcrp05kc4xf" />

        <div className="mx-auto mt-14 max-w-3xl" data-id="element-234" data-mp="11uo3vhjbyrit">
          <h3 className="text-center font-display text-xl font-black text-plum sm:text-2xl" data-id="element-235" data-mp="11td19l1mfpta">Prompt samples</h3>
          <p className="mt-2 text-center text-sm text-plum/60" data-id="element-236" data-mp="30gebddaa1ci5">Fill in the red brackets, copy, and open it in your favorite AI.</p>

          <div role="tablist" aria-label="Sample prompts" className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-237" data-mp="2wej7c10yol0o">
            {samplePrompts.map((sp, i) => <button key={sp.n} role="tab" type="button" aria-selected={active === i} onClick={() => setActive(i)} className={`rounded-full px-4 py-2 text-xs font-bold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-grape/40 ${active === i ? 'bg-plum text-white' : 'border border-grape/20 bg-white text-plum/70 hover:text-plum'}`} data-id="element-238" data-mp="359yxo82ici1i" data-mpi={i}>
                #{sp.n} · {sp.title}
              </button>)}
          </div>

          <div className="mt-5" role="tabpanel" data-id="element-239" data-mp="1qvy0irt266x">
            <PromptCard key={samplePrompts[active].n} prompt={samplePrompts[active]} data-id="element-240" data-mp="1ubcpkhkhd7t" />
          </div>
        </div>
      </div>
    </section>;
}